export default class SurveysCollectionApprovalRequestsEdit {

  constructor() {}

  render() {

    // Dup approver
    $('#addApprover').click(function() {
      let approverRows = $('.approver-row');
      let last = approverRows[approverRows.length - 1];
      let newRow = $(last).clone();
      let newId = approverRows.length;
      newRow.find('.user-id-select').attr('name', 'survey_approval_request[approvers_attributes][' + newId + '][user_id]');
      newRow.find('.user-id-select').attr('id', 'survey_approval_request_approvers_attributes_' + newId + '_user_id');
      newRow.find('.primary-select').attr('name', 'survey_approval_request[approvers_attributes][' + newId + '][primary]');
      newRow.find('.primary-select').attr('id', 'survey_approval_request_approvers_attributes_' + newId + '_primary');
      $('.approver-rows-container').append(newRow);

      $('.remove-approver-row').off().click(function() {
        let len = $('.approver-row').length;
        if (len > 1) {
          $(this).closest('.approver-row').remove();
        }
      })

    });

    $('.remove-approver-row').click(function() {
      let len = $('.approver-row').length;
      if (len > 1) {
        $(this).closest('.approver-row').remove();
      }
    })

  }

}